import {SketchPicker} from "react-color";
import {MouseEvent, useState} from "react";
import {Button, Menu} from "@mui/material";
import {useFormikContext} from "formik";

const ColorPicker = ({name, title}: { name: string; title?: string }) => {
    const [sketchPickerColor, setSketchPickerColor] = useState({
        r: "241",
        g: "112",
        b: "19",
        a: "1",
    });
    // destructuring rgba from state
    const {r, g, b, a} = sketchPickerColor;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const formikContext = useFormikContext();
    return (
        <div>
            <Button
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
            >
                {title || "انتخاب کنید"}
            </Button>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                sx={{
                    "& div": {
                        "& ul": {
                            paddingTop: 0,
                            paddingBottom: 0,
                        },
                    },
                }}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <SketchPicker
                    onChange={(color) => {
                        // @ts-ignore
                        setSketchPickerColor(color.rgb);
                        // @ts-ignore
                        formikContext.setFieldValue(name, color.rgb);
                    }}
                    // @ts-ignore
                    color={sketchPickerColor}
                />
            </Menu>
        </div>
    );
};

export default ColorPicker;
